import React from 'react';
import { Typography, Stack, Button, useTheme, Divider, Box, ButtonBase } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import route from '../../../utils/Routes';
import BackButton from '../../../components/BackButton';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery, useQueryClient } from 'react-query';
import { isEmpty, isNotEmpty, NumberFormatter } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import ScrollBox from '../../../components/ScrollBox';
import BgBoxOld from '../../../components/BgBoxOld';
import LabelTxt from '../../../components/LabelTxt';
import { getSingleProdReqServ, updateProdReqStatusServ } from '../../../services/prodreq-service';
import ProdReqTimeline from '../../../components/ProdReqTimeline';
import ReqInfoCard from './ReqInfoCard';
import constants from '../../../utils/Constants';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';
import { useState } from 'react';
import NotesMdl from '../../../components/NotesMdl';
import MessagePopUp from '../../../components/MessagePopUp';
import { sendPOServ } from '../../../services/com-service';



function ProdReqInfoPage({ type = 'amtc' }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation()
    const [searchParams] = useSearchParams();
    const queryClient = useQueryClient();
    const prodReqId = searchParams.get("prodReqId");
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const namestyle = { fontSize: 12, fontWeight: 500, display: "inline-block", width: 120 }
    const detailstyle = { fontSize: 12, fontWeight: 400, display: "inline-block" }
    const { isLoading, isError, error, data: reqData } = useQuery([QueryKey.prodReqInfo, prodReqId],
        () => getSingleProdReqServ(prodReqId),
        {
            enabled: isNotEmpty(prodReqId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });
    const [access, setAccess] = useState({ canEdit: false, canApprove: false, canGenPo: false })
    const [payload, setPayload] = useState(null)
    const [notesMdl, setNotesMdl] = useState(false);
    const handleNotesMdlClose = () => setNotesMdl(false);
    const [poMsgOpen, setPoMsgOpen] = useState(false);
    const handlePoMsgMdlOpen = () => setPoMsgOpen(true);
    const handlePoMsgMdlClose = () => setPoMsgOpen(false);
    const dialogMessage = {
        title: "Order Request Generated  Successfully",
        description: "",
        buttonText: `Order Request : ${prodReqId.replace("PR", "OR")}`
    };

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!reqData)
            return
        const canEdit = getEditAccess(reqData, ctxtUser?.userType)
        const canApprove = getApproveAccess(reqData, ctxtUser?.userType)
        const canGenPo = getGenPoAccess(reqData, ctxtUser?.userType)
        setAccess({ canEdit, canApprove, canGenPo })
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [reqData]);

    useEffect(() => {
        if (type === "amtc") {
            setNavComValue({ comId: reqData?.comId });
            return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, reqData?.comId]);

    //ENUM('approved', 'held', 'edited', 'created')

    function getEditAccess(data, userType) {
        const { status, statusLevel } = data?.currStatusObj || {};
        const { requestor, approver, line_manager, focal_point } = data;
        const cs = { ...constants }

        if (type === "amtc")
            return false

        if (['pogen'].includes(status))
            return false
        if (userType === cs.requestor) {
            if (isNotEmpty(requestor) && isEmpty(approver) && isEmpty(line_manager) & isEmpty(focal_point))
                return true;
            return false;
        }
        if (userType === cs.approver) {
            if (isNotEmpty(line_manager) || isNotEmpty(focal_point))
                return false
            if (['approved', 'held'].includes(status))
                return false
            return true;
        }
        if (userType === cs.lineManager) {
            if (statusLevel === cs.approver) {
                if (isEmpty(requestor))
                    return true
                if (['approved'].includes(status))
                    return true
            }
            if (statusLevel === cs.lineManager) {
                if (['edited', 'created'].includes(status))
                    return true
            }
            return false
        }
        if (userType === cs.focalPoint) {
            if (statusLevel === cs.approver) {
                if (['held'].includes(status))
                    return false
                else return true
            }
            if (statusLevel === cs.lineManager) {
                if (['approved'].includes(status))
                    return false
            }
            if (statusLevel === cs.focalPoint) {
                if (['edited'].includes(status))
                    return true
            }
            return false
        }
    }

    function getApproveAccess(data, userType) {
        const { status, statusLevel } = data?.currStatusObj || {};
        const { requestor, approver, line_manager, focal_point } = data;
        const cs = { ...constants }

        if (type === "amtc")
            return false

        if (['pogen'].includes(status))
            return false
        if (userType === cs.requestor)
            return false;

        if (userType === cs.approver) {
            if (isEmpty(requestor))
                return false
            if (isNotEmpty(line_manager) || isNotEmpty(focal_point))
                return false
            if (['approved', 'held'].includes(status))
                return false
            return true;
        }
        if (userType === cs.lineManager) {
            if (statusLevel === cs.approver) {
                if (isEmpty(requestor))
                    return true
                if (['approved'].includes(status))
                    return true
            }
            if (statusLevel === cs.lineManager) {
                if (isEmpty(approver))
                    return false;
                if (['edited'].includes(status))
                    return true
            }
            return false
        }
        if (userType === cs.focalPoint) {
            return false
        }
    }


    function getGenPoAccess(data, userType) {
        const { status, statusLevel } = data?.currStatusObj || {};
        const { requestor } = data;
        const cs = { ...constants }
        if (['pogen'].includes(status))
            return false
        if (userType === cs.focalPoint) {
            if (statusLevel === cs.approver) {
                if (['held'].includes(status))
                    return false
                else return true
            }
            if (statusLevel === cs.lineManager) {
                if (['approved'].includes(status))
                    return true
            }
            if (statusLevel === cs.focalPoint) {
                if (['edited'].includes(status))
                    return true
            }
            return false
        }
        return false
    }

    async function handleStatusClick(status) {
        const payload = {
            status
        }
        setPayload(payload);
        setNotesMdl(true);
    };

    function handleEditBtnClick() {
        navigate(route.cEditProdReq, { state: { prodReqId } });
    };


    async function handleMdlSave({ editRemarks }) {
        setNotesMdl(false)
        setLoadingScreen(true);
        try {
            const reqBody = {
                remarks: editRemarks, ...payload
            }
            const { message } = await updateProdReqStatusServ(reqBody, prodReqId);
            queryClient.invalidateQueries();
            notify("success", message);
            navigate(`${route.cProdreqinfo}/?prodReqId=${prodReqId}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleGenPo() {
        setLoadingScreen(true);
        try {
            const reqBody = {
                prodReqIdStrg: prodReqId
            }
            const { message } = await sendPOServ(reqBody);
            queryClient.invalidateQueries();
            notify("success", message);
            handlePoMsgMdlOpen()
            navigate(0);
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    function handleProdClick(i) {
        if (type === 'amtc')
          navigate(`${route.aProduct}/?prodId=${i?.amtcProdIdStrg}`);
        else
        navigate(`${route.cProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
    }

    function handleViewPoClick(poId) {
        navigate(`${route.cPoInfo}/?poId=${poId}`);
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"} >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <BackButton />
                <Typography style={{ fontSize: 18, fontWeight: 500 }} >Product Request Information</Typography>
                <Stack>
                    {access.canEdit &&
                        <Button variant='outlined' onClick={handleEditBtnClick} sx={{
                            fontSize: 13, ml: 5, color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                        }}>Edit Info</Button>}
                    {(reqData?.currStatus === "pogen" && type === "com") && ((ctxtUser?.userType === constants.focalPoint || ctxtUser?.userType === constants.lineManager) ?
                        <Button variant="contained" onClick={() => handleViewPoClick(prodReqId.replace("PR", "OR"))} sx={{
                            borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontWeight: 600, fontSize: 13,
                            color: "rgba(7, 42, 200, 1)"
                        }} >
                            View Order Request ({reqData?.poIdStrg})</Button> : <Box sx={{
                                borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontWeight: 600, fontSize: 13,
                                color: "rgba(7, 42, 200, 1)", px: 2, py: 0.5
                            }} >Order Request ID : ({reqData?.poIdStrg})</Box>)
                    }
                </Stack>
            </Stack>
            <BgBoxOld height={"93%"} py={1} px={1}>
                <Stack direction={"row"} height={"100%"} width={"100%"} position={"relative"} >
                    <Stack sx={{ height: "100%", width: "35%", marginLeft: 2 }}>
                        <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Product Request ID: {prodReqId}</Typography>
                        <Stack gap={0.7} mt={1}>
                            <LabelTxt typoname={"No. of line Items"} typodetail={(reqData?.prods || []).length} overflow={48} namestyle={namestyle} detailstyle={detailstyle} />
                            <LabelTxt typoname={"Project"} typodetail={reqData?.projName} overflow={48} namestyle={namestyle} detailstyle={detailstyle} />
                            <LabelTxt typoname={"Site Location"} typodetail={reqData?.siteLocation} overflow={48} namestyle={namestyle} detailstyle={detailstyle} />
                            <LabelTxt typoname={"Department"} typodetail={reqData?.deptName} overflow={48} namestyle={namestyle} detailstyle={detailstyle} />
                            {(ctxtUser?.userType !== constants.requestor && ctxtUser?.userType !== constants.approver) && <LabelTxt typoname={"Total Amt (Incl Tax) (OMR)"} typodetail={NumberFormatter(reqData?.totalPriceWithTax)} overflow={48} namestyle={namestyle} detailstyle={detailstyle} />}
                        </Stack>
                        <Typography sx={{ fontSize: 15, fontWeight: 600, mt: 2 }}>Timeline </Typography>
                        <Stack width={"100%"} height={"74%"}>
                            <ProdReqTimeline dataArr={reqData?.timeline || []} />
                        </Stack>
                    </Stack>
                    <Divider orientation="vertical" flexItem sx={{ height: "100%" }} />
                    <Stack sx={{ width: "64%", px: 4 }}>
                        <Stack direction={"row"} sx={{ width: "100%", justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Products</Typography>
                            <Box sx={{ backgroundColor: "rgba(253, 240, 213, 1)", px: 2, py: 0.3, borderRadius: 1 }}>
                                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>Total Quantity - {reqData?.totalQty}</Typography>
                            </Box>
                        </Stack>
                        <Divider sx={{ my: 1 }} />
                        <ScrollBox height={"60%"}>
                            {(reqData?.prods || []).map((i, index) => (
                                <ButtonBase width={"100%"} onClick={() => handleProdClick(i)} key={i?.id} sx={{ marginBottom: 1 }}>
                                    <Stack width={"100%"}>
                                        <ReqInfoCard i={i}  />
                                        <Divider sx={{ mt: 1 }} />
                                    </Stack>
                                </ButtonBase>
                            ))}
                        </ScrollBox>
                        {reqData && <CtrlLabelTxtFieldInfo value={reqData?.description ?? ""} readOnly={true} name="description" title="Remarks" width={"100%"} height={100} borderRadius={1} rows={4} multiline={true} />}
                    </Stack>
                    {access.canApprove &&
                        <Box sx={{ position: "absolute", bottom: 2, right: 20 }}>
                            <Button variant="outlined" onClick={async () => handleStatusClick("held")} sx={{
                                fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                                color: theme.palette.custom.btn, mr: 2,
                            }}>HOLD</Button>
                            <Button variant="contained" onClick={async () => handleStatusClick("approved")} sx={{
                                borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", width: 100, height: 40, fontWeight: 600,
                                color: "rgba(7, 42, 200, 1)"
                            }} >
                                APPROVE</Button>
                        </Box>}
                    {(access.canGenPo && type === "com") &&
                        <Box sx={{ position: "absolute", bottom: 2, right: 20 }}>
                            <Button variant="contained" onClick={handleGenPo} sx={{
                                borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", height: 40, fontWeight: 600,
                                color: "rgba(7, 42, 200, 1)"
                            }} >
                                GENERATE ORDER REQUEST</Button>
                        </Box>}
                </Stack>
            </BgBoxOld>
            {payload && <NotesMdl modalOpen={notesMdl} handleModalClose={handleNotesMdlClose} handleMdlSave={handleMdlSave} payload={payload} />}
            <MessagePopUp isOpen={poMsgOpen} onClose={handlePoMsgMdlClose} message={dialogMessage} />
        </Box>
    );
}
export default ProdReqInfoPage;